import React from "react"

import { GraphSVGLayers } from "../../../../../components/shared_components_registration"
import { downsample } from "../utils"
import ObservationSVGLayer from "./ObservationSVGLayer"
import { withPlotSettingsConfig } from "../../../../config/PlotSettingsConfigProvider"

const ObservationPlotSVG = ({
  x,
  y1,
  y2,
  loading,
  plot_type,
  filteredLayers,
  runEventLabels = [],
  runID,
  timeExtractor, // From PlotSettingsConfigProvider
  downsampleObservations, // From PlotSettingsConfigProvider
}) => {
  return (
    <>
      {/*------ Application specific extra graph elements ------*/}
      <GraphSVGLayers x={x} y={y1} layers={filteredLayers} runEventLabels={runEventLabels} runID={runID} />

      {/* Plot trends are created with svg for a more refined view */}
      {!loading &&
        filteredLayers.map((layer, index) => {
          let refLayer = { ...layer }
          if (downsampleObservations) {
            refLayer = downsample(layer, plot_type, x, timeExtractor, 1.0)
          }
          return (
            <ObservationSVGLayer
              key={index}
              x={x}
              y={refLayer.axis2 ? y2 : y1}
              timeExtractor={timeExtractor}
              {...refLayer}
            />
          )
        })}
    </>
  )
}

export default withPlotSettingsConfig(ObservationPlotSVG)
